import { useRef } from 'react';
import axios from 'axios';

const useAbortableRequest = () => {
    const abortControllerRef = useRef(null);

    // Cria um novo AbortController e retorna o sinal
    const createAbortController = () => {
        if (abortControllerRef.current) {
            abortControllerRef.current.abort(); // Cancela qualquer requisição em andamento
        }
        abortControllerRef.current = new AbortController();
        return abortControllerRef.current.signal;
    };

    // Cancela qualquer requisição em andamento
    const cancelRequests = () => {
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }
    };

    // Função auxiliar para fazer requisições com cancelamento
    const fetchWithAbort = async (url, options = {}) => {
        const signal = createAbortController();
        try {
            const response = await axios(url, { ...options, signal });
            return response.data;
        } catch (error) {
            if (axios.isCancel(error)) {
                console.log('Requisição cancelada');
            } else {
                console.error('Erro na requisição:', error);
                throw error;
            }
        }
    };

    return { createAbortController, cancelRequests, fetchWithAbort };
};

export default useAbortableRequest;